<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    return {
      cdata: {
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData1: [
          42,
          28,
          45,
          48,
          18,
          57,
          67,
          35,
          44,
          35,
          61,
          77,
          51,
          40,
          52
        ],
        rateData: []
      },
      data: [
        [
          42,
          28,
          45,
          48,
          18,
          57,
          67,
          35,
          44,
          35,
          61,
          77,
          51,
          40,
          52
        ], [
          67,
          35,
          44,
          42,
          28,
          45,
          48,
          18,
          57,
          35,
          61,
          77,
          51,
          40,
          52
        ], [
          42,
          28,
          67,
          35,
          44,
          35,
          61,
          77,
          45,
          48,
          18,
          57,
          51,
          40,
          52
        ]
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'device 中下'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData1 = this.data[index]

      index++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>